var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup_fiexd message_index"},[_c('section',{class:{red: _vm.messagesValue.type == '2' , ccc: _vm.messagesValue.type == '3' }},[_vm._v(" "+_vm._s(_vm.messagesValue.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }